module.exports = __webpack_public_path__ + "static/media/perfil.e23c5353.svg";